import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const SomeThingBrokenIcon: React.FC<IStyledSVGIconProps> = () => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="25.35" 
      height="23.787" 
      viewBox="0 0 25.35 23.787"
      style={{ enableBackground: "new 0 0 48 46;" }}
      xmlSpace="preserve"
    >
      <g id="Rejection_OnlineReject" transform="translate(0.1 0.25)">
        <path id="Path_391" data-name="Path 391" d="M23.437,18.771H22.4v6.771H14.9l-1.042,1.042H11.667l-1.042-1.042H2.6V13.563a.492.492,0,0,1,.521-.521H7.812V12H3.125a1.535,1.535,0,0,0-1.562,1.563V25.542H0v1.042a2.579,2.579,0,0,0,2.6,2.6H22.4a2.579,2.579,0,0,0,2.6-2.6V25.542H23.437Zm.521,7.813A1.535,1.535,0,0,1,22.4,28.146H2.6a1.535,1.535,0,0,1-1.562-1.562h9.167l1.042,1.042h3.021l1.042-1.042Z" transform="translate(0 -5.75)" fill="#007bc3" stroke="#007bc3" stroke-width="0.2"/>
        <path id="Path_392" data-name="Path 392" d="M30.583,0h-12.5A2.089,2.089,0,0,0,16,2.083V8.854h1.042V2.083a1.045,1.045,0,0,1,1.042-1.042h12.5a1.045,1.045,0,0,1,1.042,1.042v8.333a1.045,1.045,0,0,1-1.042,1.042H26.208L22.25,15.417V11.458h-3.6V12.5h2.563v2.917a1.029,1.029,0,0,0,.625.937.981.981,0,0,0,.417.1,1.028,1.028,0,0,0,.729-.312L26.625,12.5h3.958a2.089,2.089,0,0,0,2.083-2.083V2.083A2.089,2.089,0,0,0,30.583,0Z" transform="translate(-7.667)" fill="#007bc3" stroke="#007bc3" stroke-width="0.5"/>
        <path id="Path_395" data-name="Path 395" d="M28.029,12.717l1.979-1.979,1.979,1.979.729-.729-1.979-1.979,1.979-1.979L31.987,7.3,30.008,9.279,28.029,7.3l-.729.729,1.979,1.979L27.3,11.987Z" transform="translate(-13.081 -3.498)" fill="#007bc3" stroke="#007bc3" stroke-width="1"/>
      </g>
    </StyledSVGIcon>
  );
};
